
/** API接続のベースURL **/
export const apiURL = process.env.REACT_APP_API_URL;
export const fileApiURL = process.env.REACT_APP_FILE_API_URL;
export const fileURL = process.env.REACT_APP_FILE_URL;